import React from 'react';
import ShellFooter from '@/src/components/ShellFooter';
import useIsDesktop from '@/src/hooks/useIsDesktopLayout';

const FormFooter = ({ children, hideBorderTop = true }) => {
  const isDesktop = useIsDesktop();

  return (
    <ShellFooter withPadding hideBorderTop={hideBorderTop || isDesktop}>
      {children}
    </ShellFooter>
  );
};

export default FormFooter;
